import styled from "styled-components";

const MajorDev = (props: any) => {
  return (
    <Wapper>
      <h1>{props.Data.Major}</h1>
      <Content>
        {props.Data.des.map((item:any , index:number)=>{
            return(
                <Item key={index} >
                    <div className="Icon-MajorDev">
                        <img src={item.img} alt=''/>
                    </div>
                    <p>{item.text}</p>
                </Item>
            )
        })}
      </Content>
    </Wapper>
  );
};
export default MajorDev;

const Wapper = styled.div`
  width: 100%;
  padding-top: 36px;
  h1 {
    color: #333333;
    font-size: 40px;
    font-weight: 700;
    font-family: ManropeBold;
    margin-bottom: 35px;
  }
  @media only screen and (max-width: 1133px){
    h1{
      font-size: 20px;
      line-height: 36px;
    }
  }
`;
const Content = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: auto;
  justify-content: space-between;
  p{
    line-height: 150%;
  }
`;
const Item = styled.div`
  width: 31.5%;
  display: flex;
  .Icon-MajorDev{
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
    background-color: #F7DA57;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 24px;
  }
  p{
    color: #666666;
    font-size: 16px;
    font-weight: 400;
    font-family: ManropeRegular;
  }
  @media only screen and (max-width: 1132px){
    flex-direction: column;
    .Icon-MajorDev{
      margin-bottom: 16px;
    }
  }
  @media only screen and (max-width: 743px){
    width: 100%;
    flex-direction: row;
    margin-bottom: 24px;
  }
`